/**
 * Centralized environment variable access.
 * All VITE_ env vars must be accessed through this file —
 * never call import.meta.env directly in feature code.
 */

export const ENV = {
  BACKEND_URL: import.meta.env.VITE_BACKEND_URL ?? 'http://localhost:3000/api',
  APP_NAME:    import.meta.env.VITE_APP_NAME    ?? 'After Summit',
  APP_ENV:     import.meta.env.VITE_APP_ENV     ?? 'development',

  // Booleans — Vite env vars are always strings
  ENABLE_DEVTOOLS: import.meta.env.VITE_ENABLE_DEVTOOLS === 'true',
  ENABLE_MOCK:     import.meta.env.VITE_ENABLE_MOCK     === 'true',

  // Derived helpers
  IS_DEV:  import.meta.env.DEV,
  IS_PROD: import.meta.env.PROD,
}
